import apiClient from "./apiService";

// Fetch Orders
export const fetchOrders = async (page = 1, search = "", status = "") => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("search", search ?? "");
    params.append("status", status ?? "");
    const response = await apiClient.get(
      `/admin/orders/admin-index?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get single order
export const fetchOrder = async (id) => {
  try {
    const response = await apiClient.get(`/api/order/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update order
export const updateOrderStatus = async (id, data) => {
  try {
    const response = await apiClient.put(`/admin/orders/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
